module.exports = __webpack_public_path__ + "media/images/athletes/3446-c6624508fdaf6e88685d2c28a30d2731.png";